export enum FeatureKeys {
  AllLanguages = "languages",
  BoxOffersByUser = "boxOffersByUser",
  TimeZone = "timeZone",
  PayOutOfBand = "payOutOfBand",
  ForceSubscriptionAcceptation = "forceSubscriptionAcceptation",
  CoachSpaceAccess = "coachSpace",
}

export const DEFAULT_ACTIVATED_FEATURES: FeatureKeys[] = []

export const DEV_DEFAULT_ACTIVATED_FEATURES: FeatureKeys[] = [
  FeatureKeys.AllLanguages,
  FeatureKeys.PayOutOfBand,
  FeatureKeys.ForceSubscriptionAcceptation,
  // FeatureKeys.CoachSpaceAccess,
]
